module.exports = __webpack_public_path__ + "img/Walnut.84bf0f97.png";